import { Fraga } from "@/types/riskbedomning";

export const bruksskedeFragor: Fraga[] = [
  // Runt byggnadsverket & utomhusmiljö
  {
    id: "bruksskede-runt-huvudfraga",
    text: "Kan arbeten och tillgänglighet runt byggnadsverket innebära risker för skador eller ohälsa?",
    kategori: "Runt byggnadsverket & utomhusmiljö",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan bristande identifiering eller planering av snöröjning, takskottning, fasadarbeten och markskötsel skapa risk för arbetsmiljöproblem?",
      "Kan otillräckliga ytor eller utrymmen för dessa arbeten skapa risk för arbetsskador?",
      "Riskerar osäkert tillträde för personer eller utrustning att orsaka olyckor?",
      "Kan bristande tillgänglighet för arbetstagare med funktionsnedsättning skapa risk för arbetsmiljöproblem?",
      "Kan markbeläggning eller ytskikt skapa risk för halkolyckor?",
      "Kan avsaknad av ledstänger på båda sidor i trappor skapa risk för fallolyckor?"
    ]
  },

  // Skyddsräcken, gångvägar & entréer ute  
  {
    id: "bruksskede-skydd-huvudfraga",
    text: "Kan skyddsräcken, gångvägar och entréer utomhus innebära risker för skador eller ohälsa?",
    kategori: "Skyddsräcken, gångvägar & entréer ute",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan avsaknad av skyddsräcken vid gångvägar, trappor, ramper och nivåskillnader skapa risk för fallolyckor?",
      "Kan skyddsräcken som inte uppfyller kraven skapa risk för fall eller skador?",
      "Kan entréer som inte är lätta att nå eller tillgängliga för personer med funktionsnedsättning skapa risk för arbetsmiljöproblem?",
      "Kan avsaknad av plats för parkering eller avlämning nära entréer skapa risk för arbetsmiljöproblem?",
      "Kan förbindelseleder som inte medger säker förflyttning eller är olämpliga för räddningstjänst skapa risk för skador vid nödsituationer?",
      "Kan förbindelseleder som inte fungerar för tunga eller stora transporter skapa risk för arbetsskador?",
      "Kan fordon som inte kan vända säkert utan backning skapa risk för kollisioner eller olyckor?"
    ]
  },

  // Avfall & markskötsel
  {
    id: "bruksskede-avfall-huvudfraga",
    text: "Kan arbetet med avfallshantering eller markskötsel innebära risker för skador eller ohälsa?",
    kategori: "Avfall & markskötsel",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan otillräckligt arbetsutrymme eller dålig ergonomi vid avfallshantering skapa risk för belastningsskador?",
      "Kan markskötsel som inte kan utföras säkert skapa risk för arbetsolyckor?"
    ]
  },

  // Utomhusbelysning & underhåll
  {
    id: "bruksskede-belysning-ute-huvudfraga",
    text: "Kan utomhusbelysning, skyltar och fasadunderhåll innebära risker för skador eller ohälsa?",
    kategori: "Utomhusbelysning, skyltar & fasadunderhåll",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan utomhusbelysning som inte uppfyller funktionerna för säker förflyttning skapa risk för snubbling, fall eller kollisioner?",
      "Kan belysning eller skyltar som inte kan rengöras eller bytas på ett säkert sätt skapa risk för fallolyckor vid underhåll?",
      "Kan fasadunderhåll eller fönsterputsning som inte kan ske säkert eller där utrymme för ställning saknas skapa risk för fall från höjd?"
    ]
  },

  // Verksamheter i byggnadsverket  
  {
    id: "bruksskede-verksamhet-huvudfraga",
    text: "Kan planerade verksamheter och lokalutformning innebära risker för skador eller ohälsa?",
    kategori: "Verksamheter i byggnadsverket (inne)",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan bristande identifiering av planerade verksamheter eller arbeten i byggnaden skapa risk för oförutsedda arbetsmiljöproblem?",
      "Kan otillräckliga eller olämpliga lokaler eller utrymmen skapa risk för arbetsmiljöproblem?"
    ]
  },

  // Trapphus & driftutrymmen
  {
    id: "bruksskede-trapphus-huvudfraga",
    text: "Kan tillfälliga arbeten i trapphus, soprum och driftutrymmen innebära risker för skador eller ohälsa?",
    kategori: "Trapphus, soprum & driftutrymmen",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan bristande planering för tillfälliga arbeten i trapphus skapa risk för fall eller kollisioner?",
      "Kan otillräckligt utrymme i soprum skapa risk för belastningsskador vid hantering?",
      "Kan begränsad åtkomst eller arbetsutrymme i driftutrymmen skapa risk för arbetsskador?"
    ]
  },

  // Hygien & riskfyllda verksamheter
  {
    id: "bruksskede-hygien-huvudfraga",
    text: "Kan hygien, riskfyllda verksamheter och processer innebära risker för skador eller ohälsa?",
    kategori: "Hygien, riskfyllda verksamheter & processer",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan hygienutrymmen som inte kan anpassas för vård- och omsorgsarbetsmiljö skapa risk för smittspridning eller arbetsskador?",
      "Kan lokaler med särskilda risker som inte är anpassade för riskerna skapa risk för skador eller ohälsa?",
      "Kan processer som kräver särskilda lokaler eller processventilation men som inte hanteras korrekt skapa risk för exponering för farliga ämnen?"
    ]
  },

  // Ergonomi & framtida förändringar
  {
    id: "bruksskede-ergonomi-huvudfraga",
    text: "Kan ergonomi, service och framtida förändringar innebära risker för skador eller ohälsa?",
    kategori: "Ergonomi, service & framtida förändringar",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan dålig ergonomi i arbetsplatser eller serviceområden skapa risk för belastningsskador?",
      "Kan bristande planering för framtida förändringar skapa risk för osäkra arbetsförhållanden?",
      "Kan otillräcklig flexibilitet i lokalutformningen skapa risk för arbetsmiljöproblem vid ombyggnationer?"
    ]
  },

  // Personalutrymmen & tillgänglighet  
  {
    id: "bruksskede-personal-huvudfraga",
    text: "Kan personalutrymmen och tillgänglighet inne innebära risker för skador eller ohälsa?",
    kategori: "Personalutrymmen & tillgänglighet inne",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan personalutrymmen som inte räcker till eller inte är tillgängliga skapa risk för bristande återhämtning eller stress?",
      "Kan otillgodosedda tillgänglighetsbehov för olika funktionsnedsättningar skapa risk för arbetsmiljöproblem?",
      "Kan lokaler som inte är överskådliga eller saknar logiska samband skapa risk för stress eller olyckor?"
    ]
  },

  // Belysning & golv inne
  {
    id: "bruksskede-belysning-inne-huvudfraga",
    text: "Kan belysning och golvegenskaper inne innebära risker för skador eller ohälsa?",
    kategori: "Belysning inne",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan golvens egenskaper skapa risk för snubbling eller halkolyckor, eller kan avsaknad av halksäkra ytor skapa risk för fall?",
      "Kan golv som inte är anpassade för trucktrafik eller tyngre rullande hantering skapa risk för skador på utrustning eller personal?"
    ]
  },

  // Entréer & förflyttning inne
  {
    id: "bruksskede-entrer-huvudfraga",
    text: "Kan entréer, dörrar, portar och hissar innebära risker för skador eller ohälsa?",
    kategori: "Entréer, dörrar, portar, hissar",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan entréer, dörrar eller portar som inte ger tillgänglighet skapa risk för arbetsmiljöproblem eller olyckor?",
      "Kan personalentréer som inte är säkra skapa risk för hot, våld eller intrång?",
      "Kan avsaknad av hiss eller otillräckligt antal hissar skapa risk för belastningsskador vid bärande?",
      "Kan otillräcklig dörrbredd skapa risk för kollisioner eller försvårad materialhantering?",
      "Kan kvarstående trösklar eller enstaka trappsteg i förbindelseleder skapa risk för snubbling?"
    ]
  },

  // Trappor & färdvägar  
  {
    id: "bruksskede-trappor-huvudfraga",
    text: "Kan trappor och alternativa färdvägar innebära risker för skador eller ohälsa?",
    kategori: "Trappor & alternativa färdvägar",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan olämpliga trappmått eller avsaknad av vilplan skapa risk för fallolyckor?",
      "Kan avsaknad av ledstång eller spiraltrappor som begränsar tillgängligheten skapa risk för fall eller arbetsmiljöproblem?",
      "Kan avsaknad av alternativa färdvägar till trappor skapa risk för belastningsskador vid bärande?"
    ]
  },

  // Utrymning & brandskydd
  {
    id: "bruksskede-utrymning-huvudfraga",
    text: "Kan utrymning, larm och brandskydd innebära risker för skador eller ohälsa?",
    kategori: "Utrymning, larm & brandskydd",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan osäker utrymning för personer med funktionsnedsättning skapa risk för skador vid brand eller utrymning?",
      "Kan avsaknad av utrymningsplan eller otydlig placering skapa risk för försenad eller förvirrad utrymning?",
      "Kan otillräckligt antal eller utformning av utrymningsvägar skapa risk för ineffektiv utrymning?",
      "Kan otillräcklig belysning eller nödbelysning i utrymningsvägar skapa risk för fall eller försenad utrymning?",
      "Kan otillräcklig utrymningsskyltning eller markering skapa risk för förvirring vid utrymning?",
      "Kan avsaknad av tillfälliga utrymningsplatser där de behövs skapa risk för skador vid utrymning?",
      "Kan avsaknad eller felval av detektorer eller larm skapa risk för försenad upptäckt av brand?",
      "Kan avsaknad av särskilda larm för instängning eller hot/våld skapa risk för försenad hjälp?",
      "Kan larm som inte hörs eller uppfattas skapa risk för försenad utrymning?",
      "Kan avsaknad av automatiskt släcksystem där det krävs skapa risk för brandspridning?",
      "Kan brandredskap med olämpliga placeringar skapa risk för försenad brandbekämpning?"
    ]
  },

  // Skyltning & skydd
  {
    id: "bruksskede-skyltning-huvudfraga",
    text: "Kan skyltning, skydd och första hjälpen innebära risker för skador eller ohälsa?",
    kategori: "Skyltning, skydd & första hjälpen",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan avsaknad av varnings-, påbuds- eller förbudsskyltar för riskområden skapa risk för olyckor?",
      "Kan avsaknad av skyddsräcken i särskilda riskområden skapa risk för fallolyckor?",
      "Kan glasytor utan avskärmning eller skydd mot sammanstötning skapa risk för personskador?",
      "Kan avsaknad av nöddusch eller ögondusch där stänkrisk föreligger skapa risk för allvarliga kemiska skador?"
    ]
  },

  // Farliga ämnen & processer
  {
    id: "bruksskede-farligt-huvudfraga",
    text: "Kan farliga ämnen, heta arbeten och damm/batterier innebära risker för skador eller ohälsa?",
    kategori: "Farliga ämnen, heta arbeten & damm/batterier",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan farliga ämnen, svetsning eller damm utan adekvata åtgärder skapa risk för förgiftning, brand eller explosion?",
      "Kan varumottag eller ramper som är dåligt utformade skapa risk för arbetsskador vid lastning eller lossning?",
      "Kan avgaser som sugs in via varumottag skapa risk för exponering för hälsofarliga ämnen?"
    ]
  },

  // Trafikseparation  
  {
    id: "bruksskede-trafik-huvudfraga",
    text: "Kan trafikseparation och godsflöden innebära risker för skador eller ohälsa?",
    kategori: "Trafikseparation & godsflöden",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan bristande separation mellan gångtrafik och fordonstrafik skapa risk för påkörningsolyckor?",
      "Kan otillräckligt utrymme för transporter vid mottagningen skapa risk för kollisioner eller arbetsskador?",
      "Kan godstyper eller uppställning som inte ryms skapa risk för blockerade vägar eller olyckor?"
    ]
  },

  // Rullande hantering & lyft
  {
    id: "bruksskede-lyft-huvudfraga",
    text: "Kan rullande hantering och lyft innebära risker för skador eller ohälsa?",
    kategori: "Rullande hantering & lyft",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan utformning som förhindrar rullande hantering skapa risk för manuella lyft och belastningsskador?",
      "Kan avsaknad av godshiss eller annan lyftanordning skapa risk för belastningsskador vid bärande?",
      "Kan öppningar utan fallskydd och skydd mot nedfallande föremål skapa risk för fall eller träffskador?",
      "Kan nivåskillnader som inte skyddas eller synliggörs skapa risk för snubbling eller fall?",
      "Kan snöras eller istappar vid dörrar eller portar skapa risk för träffskador?"
    ]
  },

  // Belysning - krav & anpassning
  {
    id: "bruksskede-belysning-krav-huvudfraga",
    text: "Finns risk för otillräcklig arbetsbelysning?",
    kategori: "Belysning – krav & anpassning",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan bristande belysning göra arbetet svårt att utföra på ett säkert sätt?",
      "Finns risk att belysningen inte kan anpassas till individuella behov eller arbetsuppgifter?",
      "Kan brist på dagsljus eller otillräcklig avskärmning mot solinstrålning skapa obehag eller försämra arbetsmiljön?",
      "Kan bristande nödbelysning göra det svårt att uppfatta varningsskyltar eller se maskindelar vid ett strömavbrott?",
      "Kan belysningen tillsammans med golvets egenskaper skapa bländning eller dålig sikt?"
    ]
  },

  // Ventilation & klimat
  {
    id: "bruksskede-ventilation-huvudfraga",
    text: "Kan ventilation, klimat och luftkvalitet innebära risker för skador eller ohälsa?",
    kategori: "Ventilation, klimat & luftkvalitet",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan ventilationstyp eller luftföring som inte motsvarar uppgifterna skapa risk för dålig luftkvalitet?",
      "Kan verksamheter med krav på processventilation som inte får rätt lösning skapa risk för exponering för farliga ämnen?",
      "Kan bristande luftkvalitet eller termiskt klimat skapa risk för obehag eller hälsoproblem?",
      "Kan ventilation eller material som inte ger god luft- och ljudmiljö skapa risk för hälsoproblem eller stress?"
    ]
  },

  // Ljudmiljö & buller
  {
    id: "bruksskede-ljud-huvudfraga",
    text: "Kan ljudmiljö och buller innebära risker för skador eller ohälsa?",
    kategori: "Ljudmiljö & buller",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan ljudmiljö som inte är lämplig för planerade verksamheter skapa risk för stress eller hörselskador?",
      "Kan höga ljudnivåer i öppna kontor eller skolor som inte minimeras skapa risk för stress eller koncentrationssvårigheter?",
      "Kan kommunikationsintensiva lokaler med dålig ljudkvalitet skapa risk för stress eller missförstånd?",
      "Kan buller som inte dämpas med skärmar eller inbyggnader skapa risk för hörselskador eller stress?"
    ]
  },

  // Drift & underhåll 
  {
    id: "bruksskede-drift-huvudfraga",
    text: "Kan drift och underhåll innebära risker för skador eller ohälsa?",
    kategori: "Drift & underhåll – åtkomst och arbetsmiljö",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan drift- eller underhållsarbete som inte kan utföras på grund av bristande åtkomst skapa risk för uppskjutet underhåll eller farliga improvisationer?",
      "Kan ventilationskanaler som inte kan nås för rens eller underhåll skapa risk för dålig luftkvalitet eller brandrisk?",
      "Kan avsaknad av rullande hantering för drift- eller serviceutrustning skapa risk för belastningsskador?"
    ]
  },

  // Renhållning & tak
  {
    id: "bruksskede-renhallning-huvudfraga",
    text: "Kan renhållning, takarbeten och sotning innebära risker för skador eller ohälsa?",
    kategori: "Renhållning, tak & sotning",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan smuts eller väta som dras in via entréer skapa risk för ökad halkrisk?",
      "Kan osäker åtkomst till tak skapa risk för fallolyckor?",
      "Kan uppgång till tak utan fast stege enligt branschstandard skapa risk för fall?",
      "Kan takarbete utan takstegar eller fästpunkter för sele skapa risk för fall från höjd?",
      "Kan takmaterial som ger halkrisk vid inspektion eller underhåll skapa risk för fallolyckor?",
      "Kan ytor med låg bärighet utan skydd mot genomtramp skapa risk för fall genom tak?",
      "Kan sotning som kräver arbete på lutande eller ojämnt underlag skapa risk för fallolyckor?"
    ]
  },

  // Städbarhet & logistik
  {
    id: "bruksskede-stadbarhet-huvudfraga",
    text: "Kan städbarhet och städlogistik innebära risker för skador eller ohälsa?",
    kategori: "Städbarhet & städlogistik",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan lokaler eller inredning som försvårar städning skapa risk för belastningsskador eller dålig hygien?",
      "Kan avsaknad av våtrumsutformning där hygien eller smittrisk kräver det skapa risk för smittspridning?",
      "Kan material eller utformning som inte stöder valda städmetoder skapa risk för ineffektiv städning eller belastningsskador?",
      "Kan avsaknad av vatten eller utslagsback per våningsplan eller städområde skapa risk för belastningsskador vid hantering?",
      "Kan avsaknad av städrum eller felplacerade eller underdimensionerade städrum skapa risk för arbetsmiljöproblem?",
      "Kan otillräcklig ventilation i utrymmen för städmaskiner skapa risk för exponering för avgaser eller damm?",
      "Kan laddning av städmaskiners batterier skapa risk för brand eller elektriska olyckor?"
    ]
  },

  // Glas & installationer
  {
    id: "bruksskede-glas-huvudfraga",
    text: "Kan rengöring av glas, fönsterputs och underhåll av installationer innebära risker för skador eller ohälsa?",
    kategori: "Glas, fönsterputs & installationer",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan fönster eller glaspartier som inte kan rengöras säkert skapa risk för fallolyckor vid rengöring?",
      "Kan utvändig fönsterputsning som inte kan ske säkert skapa risk för fall från höjd?",
      "Kan demontering eller byte av installationer som inte kan ske säkert eller ergonomiskt skapa risk för skador eller belastningsskador?"
    ]
  },

  // Byggmaterial & renovering  
  {
    id: "bruksskede-byggmaterial-huvudfraga",
    text: "Kan framtida material- och renoveringsarbeten innebära risker för skador eller ohälsa?",
    kategori: "Byggmaterial & renovering",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan avsaknad av rullande hantering eller godshiss för byggmaterial och avfall skapa risk för belastningsskador vid renovering?",
      "Kan lokaler som inte kan avskiljas vid renovering med hälsofarliga ämnen skapa risk för exponering?"
    ]
  },

  // Elsäkerhet vid underhåll
  {
    id: "bruksskede-elsakerhet-underhall",
    text: "Kan elsäkerhet vid drift och underhåll innebära risker för skador eller ohälsa?",
    kategori: "Elsäkerhet vid drift & underhåll",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan avsaknad av rutiner för säker frånkoppling (LOTO) vid service och underhåll skapa risk för elolyckor?",
      "Kan bristande tillgång till elscheman och dokumentation försvåra säkert arbete på elanläggningar?",
      "Kan arbete på elanläggningar utföras av personal utan behörighet eller ESA-utbildning?",
      "Kan otydliga ansvarsgränser mellan fastighetsägare och hyresgäst skapa risk vid elunderhåll?"
    ],
    afsReferences: ["AFS 2023:11", "ELSÄK-FS 2022:1"]
  },

  // Elinstallationer i drift
  {
    id: "bruksskede-elinstallationer-drift",
    text: "Kan elinstallationer i drift innebära risker för skador eller ohälsa?",
    kategori: "Elsäkerhet vid drift & underhåll",
    fas: "bruksskede",
    followUpQuestions: [
      "Kan trasiga uttag, strömbrytare eller elcentraler som inte åtgärdas skapa risk för elchock eller brand?",
      "Kan avsaknad av periodisk kontroll av fasta elinstallationer skapa risk för brand eller personskador?",
      "Kan laddinfrastruktur för elfordon eller eldrivna maskiner skapa risk för brand eller elolyckor?",
      "Kan överlastade eluttag eller förlängningskablar som permanenta lösningar skapa risk för brand?"
    ],
    afsReferences: ["AFS 2023:11"]
  }
];